import React from 'react';
import PropTypes from 'prop-types';
import { Skeleton } from '@mui/material';
import css from './SectionSkeleton.css';

const SectionSkeleton = ({ questionsCount }) => (
    <div className={css.panel} aria-busy="true" aria-label="Loading section">
        <div className={css.header}>
            <Skeleton variant="circular" className={css.icon} />
            <div className={css.meta}>
                <Skeleton variant="text" className={css.title} />
                <Skeleton variant="text" className={css.description} />
            </div>
            <Skeleton variant="rectangular" className={css.counter} />
        </div>
        <div className={css.questions}>
            {Array.from({ length: questionsCount }, (_, index) => `skeleton-question-${index}`).map(key => (
                <div key={key} className={css.question}>
                    <div className={css.questionHeader}>
                        <Skeleton variant="circular" className={css.indicator} />
                        <div className={css.questionMeta}>
                            <Skeleton variant="text" className={css.questionTitle} />
                            <Skeleton variant="text" className={css.questionDescription} />
                        </div>
                    </div>
                    <Skeleton variant="rectangular" className={css.textarea} />
                </div>
            ))}
        </div>
    </div>
);

SectionSkeleton.propTypes = {
    questionsCount: PropTypes.number.isRequired,
};

export default SectionSkeleton;
